import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import {
  CALLOUT_FOREGROUND,
  OUTLINED_INPUT_BORDER,
  OUTLINED_INPUT_BORDER_RADIUS,
} from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
  label: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    margin: 0,
  },
  listBox: {
    border: `1px solid ${OUTLINED_INPUT_BORDER}`,
    borderRadius: OUTLINED_INPUT_BORDER_RADIUS,
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  item: {
    padding: theme.spacing(1.25, 2),
    borderBottom: `1px solid ${OUTLINED_INPUT_BORDER}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  link: {
    display: 'block',
    fontSize: '0.875rem',
    lineHeight: 1.25,
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    overflowWrap: 'anywhere',
    wordBreak: 'normal',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  slug: {
    color: CALLOUT_FOREGROUND,
    fontWeight: 700,
  },
}))

const ProfileUrlExamples = ({ examples }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Typography component="p" className={classes.label}>
        Example coach profiles
      </Typography>
      <Box className={classes.listBox}>
        <Box component="ul" className={classes.list}>
          {examples.map(example => (
            <Box component="li" key={example} className={classes.item}>
              <a
                className={classes.link}
                href={`https://www.pga.com/coach/${example}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.pga.com/coach/
                <span className={classes.slug}>{example.toLowerCase()}</span>
              </a>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

ProfileUrlExamples.propTypes = {
  examples: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default ProfileUrlExamples
